/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum InvestitionStatus {
    Geplant = 'Geplant',
    Laufend = 'Laufend',
    Abgeschlossen = 'Abgeschlossen',
    Geloescht = 'Geloescht'
  }

    export const InvestitionStatusTranslocoMap: Record<InvestitionStatus, string> = {
    [InvestitionStatus.Geplant]: 'investitionStatus.geplant',
    [InvestitionStatus.Laufend]: 'investitionStatus.laufend',
    [InvestitionStatus.Abgeschlossen]: 'investitionStatus.abgeschlossen',
    [InvestitionStatus.Geloescht]: 'investitionStatus.geloescht',
    };

    export const InvestitionStatusOptions = [
  { value: InvestitionStatus.Geplant, labelKey: 'investitionStatus.geplant' },
  { value: InvestitionStatus.Laufend, labelKey: 'investitionStatus.laufend' },
  { value: InvestitionStatus.Abgeschlossen, labelKey: 'investitionStatus.abgeschlossen' },
  { value: InvestitionStatus.Geloescht, labelKey: 'investitionStatus.geloescht' },
    ];

